<div class="main-board">
    <div class="board">
        <div class="board-header">Battery Health</div>
        <div class="board-body">
            <div>
                <ul>
                    <li>
                        <span>Max Cell Temp:</span>
                        <span>89.6°C</span>
                    </li>
                    <li>
                        <span>Min Cell Temp:</span>
                        <span>89.6°C</span>
                    </li>
                    <li>
                        <span>Max Voltage:</span>
                        <span>89.6 V</span>
                    </li>
                    <li>
                        <span>Min Voltage:</span>
                        <span>89.6 V</span>
                    </li>
                    <li>
                        <span>Voltage Spread:</span>
                        <span>0.17 V</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="board">
        <div class="board-header">Battery Health</div>
        <div class="board-body">
            <div>
                <ul>
                    <li>
                        <span>Max Cell Temp:</span>
                        <span>89.6°C</span>
                    </li>
                    <li>
                        <span>Min Cell Temp:</span>
                        <span>89.6°C</span>
                    </li>
                    <li>
                        <span>Max Voltage:</span>
                        <span>89.6 V</span>
                    </li>
                    <li>
                        <span>Min Voltage:</span>
                        <span>89.6 V</span>
                    </li>
                    <li>
                        <span>Voltage Spread:</span>
                        <span>0.17 V</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>